import React from 'react';
import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip as ChartTooltip, XAxis, YAxis } from 'recharts';
import { SectionCard } from '../common/SectionCard';
import type { ApplicationRecord } from '../../types/domain';
const buckets = [{
  label: '40–49',
  min: 40,
  max: 49,
  fill: 'var(--chart-5)'
}, {
  label: '50–59',
  min: 50,
  max: 59,
  fill: 'var(--chart-5)'
}, {
  label: '60–69',
  min: 60,
  max: 69,
  fill: 'var(--chart-3)'
}, {
  label: '70–79',
  min: 70,
  max: 79,
  fill: 'var(--chart-3)'
}, {
  label: '80–89',
  min: 80,
  max: 89,
  fill: 'var(--chart-2)'
}, {
  label: '90–100',
  min: 90,
  max: 100,
  fill: 'var(--chart-1)'
}];
export function ScoreDistribution({
  records
}: {
  records: ApplicationRecord[];
}) {
  const data = buckets.map(bucket => ({
    label: bucket.label,
    fill: bucket.fill,
    records: records.filter(record => record.aiScore >= bucket.min && record.aiScore <= bucket.max).length
  }));
  return <SectionCard title="Score distribution" description="Weighted AI scores across every record, banded by decile" data-id="element-475" data-mp="6so8m3s0cpnn">
      <div className="h-56 w-full" data-id="element-476" data-mp="2d4nk54e9pgzz">
        <ResponsiveContainer width="100%" height="100%" data-id="element-477" data-mp="2d5p7o8cgzvyl">
          <BarChart data={data} margin={{
          top: 4,
          right: 8,
          left: -20,
          bottom: 0
        }} data-id="element-478" data-mp="2qvivqog5ic79">
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" vertical={false} data-id="element-479" data-mp="2m4snn3gcbv8v" />
            <XAxis dataKey="label" tick={{
            fontSize: 11,
            fill: 'var(--muted-foreground)'
          }} tickLine={false} axisLine={{
            stroke: 'var(--border)'
          }} data-id="element-480" data-mp="30t6qvfho5lpy" />
            <YAxis allowDecimals={false} tick={{
            fontSize: 11,
            fill: 'var(--muted-foreground)'
          }} tickLine={false} axisLine={false} data-id="element-481" data-mp="39umyxgl0hbr0" />
            <ChartTooltip contentStyle={{
            fontSize: 12,
            borderRadius: 4,
            border: '1px solid var(--border)'
          }} data-id="element-482" data-mp="1ffapod1igiqu" />
            <Bar dataKey="records" radius={[2, 2, 0, 0]} data-id="element-483" data-mp="1aiu15hqeg2d8">
              {data.map(entry => <Cell key={entry.label} fill={entry.fill} data-id="element-484" data-mp="3al3cb8p2maxr" />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      <p className="mt-2 text-[11px] leading-relaxed text-muted-foreground" data-id="element-485" data-mp="3kgww9d54d6pk">
        Records below 60 are recommended for decline, 60–79 are held for manual review, and 80 and
        above are recommended to advance. Bands are configured per criteria set in the intelligence
        hub.
      </p>
    </SectionCard>;
}